/** @jsx jsx */
import React, { useEffect, useState, useContext } from "react";
import { css, jsx } from "@emotion/react";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import BookOutlinedIcon from "@mui/icons-material/BookOutlined";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { ThemeContext } from "context/ThemeContext";
import { AuthContext } from "context/Authentication";
import { postRecord } from "services/services";
import commonStyles from "templates/default/assets/styles/commonstyles/commonStyles";
import HomeSlider from "./Sections/HomeSlider.jsx";
import Header from "../../components/Header/Header.jsx";
import FeaturedProducts from "./Sections/FeaturedProducts.jsx";
import AdditionalProduct from "./Sections/AdditionalProduct.jsx";
import BestSellersSection from "./Sections/BestSellersSection.jsx";
import TopCategory from "./Sections/TopCategory.jsx";
import AllCategory from "./Sections/AllCategory.jsx";
import Footer from "templates/default/components/Footer/Footer.jsx";
import PrimaryOfferings from "./Sections/PrimaryOfferings.jsx";
import TopSuppliers from "./Sections/TopSuppliers.jsx";
import FeaturedServices from "./Sections/FeaturedServices.jsx";
import PopularServices from "./Sections/PopularServices.jsx";
import FaqView from "CommonComponents/Faqs/FaqView.jsx";
// import TopHeader from "../../components/Header/TopHeader.jsx";

const API_GetAllProductsWithFilters = "products/getallwithfilters";
export default function Home(props) {
  const context = useContext(AuthContext);
  const themeMode = useContext(ThemeContext);
  const darkMode = themeMode.state.darkMode;
  const [headerRefresh, setHeaderRefresh] = useState(true);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Filter products for different sections
  const featuredProducts = products.filter(
    (product) => product.Is_Featured === "1"
  );
  const homepageProducts = products.filter(
    (product) => product.On_Homepage === "1"
  );
  const bestSellerProducts = products.filter(
    (product) =>
      product.Product_Tags &&
      product.Product_Tags.toLowerCase().includes("best seller")
  );

  useEffect(() => {
    let isMounted = true;

    const fetchAllProducts = async () => {
      try {
        const response = await postRecord(API_GetAllProductsWithFilters, {
          Product_Category_Id: 0,
          Product_Sub_Category_Id: 0,
          Category_Name: "",
          Sub_Category_Name: "",
          Tag_Name: "",
          Sort_Column: "Modified_On",
          Sort_Type: "desc",
          Page_Index: 1,
          Records_Per_Page: 50,
          Is_Published: "1",
          Is_Deleted: "0",
          Is_Featured: "0",
          On_Homepage: "0",
          On_Mainmenu: "0",
          Is_Addon: "0",
        });

        if (isMounted && response.status === 200 && response.data) {
          // Transform the data to match the expected format
          const transformedProducts = response.data.products.map((product) => ({
            ...product,
            image:
              product.default_media && product.default_media.length > 0
                ? product.default_media[0]
                : null,
            price: product.default_inventory
              ? product.default_inventory.Total_Selling_Price
              : 0,
            combinationText: product.default_combination
              ? product.default_combination.Combination
              : "",
            averageRating: product.average_review || 0,
            reviewCount: 0, // This will be handled by individual components if needed
            Default_Media: product.default_media || [],
            Default_Inventory: product.default_inventory,
            Default_Combination: product.default_combination,
          }));
          console.log("Fetched Products:", transformedProducts);
          setProducts(transformedProducts);
          setLoading(false);
        }
      } catch (error) {
        if (isMounted) {
          // console.error("Error fetching products:", error);
          setLoading(false);
        }
      }
    };

    fetchAllProducts();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <React.Fragment>
      <Box
        sx={{
          width: "100%",
        }}
      >
        <Header
          headerRefresh={headerRefresh}
          setHeaderRefresh={setHeaderRefresh}
        />
        <HomeSlider />
        {context.state?.companyInfo?.Is_Aggregator === "1" &&
          context.state?.companyInfo?.Product_Service_Type ===
            "Product - Physical" && <PrimaryOfferings />}
        <AllCategory />

        {/* Only show product components when Product_Service_Type is "Product - Physical" or "Full suite" */}
        {(context.state?.companyInfo?.Product_Service_Type ===
          "Product - Physical" ||
          context.state?.companyInfo?.Product_Service_Type ===
            "Full suite") && (
          <>
            <FeaturedProducts
              products={featuredProducts}
              loading={loading}
              headerRefresh={headerRefresh}
              setHeaderRefresh={setHeaderRefresh}
            />
            <BestSellersSection
              products={bestSellerProducts}
              loading={loading}
              headerRefresh={headerRefresh}
              setHeaderRefresh={setHeaderRefresh}
            />
            <AdditionalProduct
              products={homepageProducts}
              loading={loading}
              headerRefresh={headerRefresh}
              setHeaderRefresh={setHeaderRefresh}
            />
          </>
        )}

        {/* Show service components when Product_Service_Type is "Product - Digital", "Service", or "Full suite" */}
        {(context.state?.companyInfo?.Product_Service_Type ===
          "Product - Digital" ||
          context.state?.companyInfo?.Product_Service_Type === "Service" ||
          context.state?.companyInfo?.Product_Service_Type ===
            "Full suite") && (
          <>
            <FeaturedServices
              headerRefresh={headerRefresh}
              setHeaderRefresh={setHeaderRefresh}
            />
            <PopularServices
              headerRefresh={headerRefresh}
              setHeaderRefresh={setHeaderRefresh}
            />
          </>
        )}

        {context.state?.companyInfo?.Is_Aggregator === "1" && <TopSuppliers />}
        <TopCategory />
        <FaqView />
        <Footer />
      </Box>
    </React.Fragment>
  );
}
